import { useEffect } from 'react';
import {
  useTranslation,
  Col,
  useShowToastNotification,
  ENotificationType,
  TRtkErrorType,
} from '@packages/utils';
import { useTheme } from 'styled-components';
import { Icon } from 'components/Base/Icon';
import { useDeleteResourceMutation } from 'redux/apiSlice/elcs.slice';
import { TRemoveResourceProps } from './RemoveResource.types';

const RemoveResource = ({
  resourceId,
  elcId,
  className,
  iconName,
  iconSize,
  setRemoveIsLoading,
  disabled = false,
}: TRemoveResourceProps) => {
  const theme = useTheme();
  const { showToastNotification } = useShowToastNotification();
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.elcs.detail.resources-tab.delete',
  });
  const [deleteResource, { isLoading }] = useDeleteResourceMutation();

  useEffect(() => {
    if (setRemoveIsLoading) {
      setRemoveIsLoading(isLoading);
    }
  }, [isLoading]);

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    if (disabled || isLoading) {
      e.preventDefault();
      return;
    }
    try {
      await deleteResource({
        ...(elcId && { elcId }),
        resourceId,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Col onClick={disabled ? undefined : handleSubmit} className={className}>
      <Icon
        icon={iconName}
        color={disabled ? '#B5B5B5' : theme.colorBlackIconColor}
        className={disabled ? '' : 'pointer'}
        size={iconSize || 24}
        tooltip={{
          title: disabled
            ? 'Global resources can only be deleted from the All ELCs page'
            : t('DELETE_TOOLTIP'),
        }}
      />
    </Col>
  );
};

export default RemoveResource;
